// Inspector translations for map data sources that are not covered by topic-docs
// (external tile sources, pseudo-tag layers, etc.).
export const translationsSources = {
  // Summieren mode: the part of a dataset a feature is from (`calculatorPartKey`), under the
  // source of the first part.
  'tilda_parkings--part--key': 'Lage',
  'tilda_parkings--part=street': 'Im Straßenraum',
  'tilda_parkings--part=off_street': 'Abseits des Straßenraums',
  'atlas_bikelanes--part--key': 'Netz',
  'atlas_bikelanes--part=bikelanes': 'Radinfrastruktur',
  'atlas_roads--part--key': 'Netz',
  'atlas_roads--part=roads': 'Straßen',
  'atlas_roads--part=paths': 'Wege',
}
